import BTC_1D_IV_PERP from "../../assets/btc_1d_iv.svg";
import BTC2_PERP from "../../assets/btc^2-perp.svg";
import NEAR_TOKEN from "../../assets/near-token.svg";
import { getTokenBySymbol } from "../tokenInfo";

const MARGIN_SYMBOL_OVERRIDES = {
  SOL: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
  ETH: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk/logo.png",
  BTC: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E/logo.png",
  USDC: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/CpMah17kQEL2wqyMKt3mZBdTnZbkbfx4nqmQMFDP5vwp/logo.png",
  USDT: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB/logo.svg",
  AVAX: "https://assets.coingecko.com/coins/images/12559/small/coin-round-red.png",
  BNB: "https://assets.coingecko.com/coins/images/825/small/binance-coin-logo.png",
  SRM: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt/logo.png",
  RAY: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R/logo.png",
  MNGO: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac/token.png",
  COPE: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh/logo.png",
  MSOL: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So/logo.png",
  FTT: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv/logo.png",
  ADA: "https://assets.coingecko.com/coins/images/975/small/cardano.png",
  LUNA: "https://assets.coingecko.com/coins/images/8284/small/luna1557227471663.png",
  MATIC: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png",
  ATOM: "https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png",
  DOT: "https://assets.coingecko.com/coins/images/12171/small/polkadot.png",
  ALGO: "https://assets.coingecko.com/coins/images/4380/small/download.png",
  LTC: "https://assets.coingecko.com/coins/images/2/small/litecoin.png",
  XRP: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png",
  APE: "https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg",
  DOGE: "https://assets.coingecko.com/coins/images/5/small/dogecoin.png",
  NEAR: NEAR_TOKEN,
  "BTC^2": BTC2_PERP,
  BTC_1D_IV: BTC_1D_IV_PERP,
  "SOL^2":
    "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
  GMT: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx/logo.png",
  SYN: "https://assets.coingecko.com/coins/images/18024/small/syn.png",
  APT: "https://assets.coingecko.com/coins/images/26455/small/aptos_round.png?1666839629",
};

export const getMarginPositionIcon = (symbol: string): string | undefined => {
  const marginSymbol = MARGIN_SYMBOL_OVERRIDES[symbol];
  if (marginSymbol) {
    return marginSymbol;
  }
  const tokenInfo = getTokenBySymbol(symbol);

  return tokenInfo?.logoURI;
};
